module.exports = __webpack_public_path__ + "static/media/EphemeralFirelight_200.ccafb2fb.jpg";